import { createFileRoute, redirect } from '@tanstack/react-router'
import { orgRoutes } from '@/lib/routes'

/**
 * A bare `/o/:slug` — no screen named.
 *
 * The App Router 404'd this, because the segment had a layout and no page. It
 * is a URL people type and truncate, though, and the workspace's front door is
 * one segment away, so it forwards rather than dead-ends.
 */
export const Route = createFileRoute('/o/$org/')({
  beforeLoad: ({ params: { org } }) => {
    throw redirect({ ...orgRoutes(org).qrCodes })
  },
})
